var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-prompt"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.buttonText)?_c('AeButton',{attrs:{"fill":"secondary"},on:{"click":function($event){return _vm.$emit('button-click')}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }